/**
 * Bot personality utilities
 * Provides helper functions for working with bot personalities
 */

export const BOT_PERSONALITIES = [
  { value: 'RANDOM', label: '🎲 Random', description: 'Random personality' },
  { value: 'BALANCED', label: '⚖️ Balanced', description: 'Well-rounded strategy' },
  { value: 'AGGRESSIVE', label: '🔥 Aggressive', description: 'High-risk, high-reward' },
  { value: 'CONSERVATIVE', label: '🛡️ Conservative', description: 'Safe, steady gains' },
  { value: 'SABOTEUR', label: '💣 Saboteur', description: 'Disrupts opponents' },
  { value: 'OPPORTUNIST', label: '📊 Opportunist', description: 'Adapts to forecasts' }
];

/**
 * Maps personality name to value
 * @param {string} personalityName - Name of the personality
 * @returns {string} - Personality value (uppercase)
 */
export const getPersonalityValue = (personalityName) => {
  if (!personalityName) return 'RANDOM';
  if (personalityName === 'Random' || personalityName === 'RANDOM') return 'RANDOM';
  
  const upperName = personalityName.toUpperCase();
  const match = BOT_PERSONALITIES.find(p => p.value === upperName);
  return match ? match.value : 'RANDOM';
};

/**
 * Gets personality label from name
 * @param {string} personalityName - Name of the personality
 * @returns {string} - Personality label with emoji
 */
export const getPersonalityLabel = (personalityName) => {
  if (!personalityName) return '🎲 Random';
  if (personalityName === 'Random' || personalityName === 'RANDOM') return '🎲 Random';
  
  const value = getPersonalityValue(personalityName);
  const match = BOT_PERSONALITIES.find(p => p.value === value);
  return match ? match.label : `🎲 ${personalityName}`;
};

/**
 * Gets personality description
 * @param {string} personalityName - Name of the personality
 * @returns {string} - Personality description
 */
export const getPersonalityDescription = (personalityName) => {
  const value = getPersonalityValue(personalityName);
  const match = BOT_PERSONALITIES.find(p => p.value === value);
  return match ? match.description : 'Random personality';
};

